import { Adresse } from '../../../identite/shared/classes/adresse';
import { Batiment } from './batiment';
import { TypeBien } from './type_bien';
import { TypeDalle } from './type_dalle';
import { TypeToiture } from './type_toiture';
import { TypeFacade } from './type_facade';
import { Mandat } from './mandat';
import { LotPiece } from '../../../piece/shared/classes/lot-piece';
import { Description } from '../../../description/shared/classes/description';
import { Diagnostic } from './diagnostic';
import { Photo } from '../../../photo/shared/classes/photo';
import { TypeTransaction } from './type_transaction';
import { TypePassation } from './type_passation';
import { formatDate } from '@angular/common';
import { Role } from '../../../identite/shared/classes/role';
import { Annonce } from './annonce';
import { LotProprietaire } from './lot-proprietaire';
import { Convention } from './convention';
import BudgetLot from "./BudgetLot";
import {AgrementsClient} from "../../../identite/shared/classes/agrements-client";
import { TranchesLot } from './tranches-lot';
import { Identite } from '../../../identite/shared/classes/identite';

export class Lot {

    id: string;
    ref: string;
    ref_metier: string;
    statut: string;
    draft: string;
    agence_bureaux_id: string;
    batiments_id: string;
    roles_id_proprietaire: string;
    roles_id_locataire: string;
    tpb_id: string;
    tpd_id: string;
    description: string;
    date_achat: string;
    date_vente: string;
    achat_type: string;
    surface: string;
    surface_terrain_ares: string;
    surface_terrain: string;
    surface_totale: string;
    surface_utile: string;
    surface_annexe_m2: string;
    surface_balcon: string;
    surface_terrasse: string;
    etage: string;
    numero: string;
    adresses_id: string;
    adresse: Adresse;
    batiment: Batiment;
    type_bien: TypeBien;
    type_dalle: TypeDalle;
    type_toiture: TypeToiture;
    type_facade: TypeFacade;
    mandat: Mandat;
    convention: Convention;
    nb_etages: string;
    annee_construction: string;
    nb_chambres: string;
    nb_pieces: string;
    nb_parkings: string;
    nb_sdb: string;
    chauffage_appareil: string;
    chauffage_energie: string;
    eau_chaude: string;
    piscine: boolean;
    jardin: boolean;
    terrasse: boolean;
    balcon: boolean;
    meuble: boolean;
    ascenseur: boolean;
    digicode: boolean;
    interphone: boolean;
    visiophone: boolean;
    acces_handicape: boolean;
    wellness: boolean;
    loggia: boolean;
    surface_loggia: string;
    computed_name: string;
    url: string;
    visite_virtuelle: string;
    ref_auto: boolean = true;

    nb_garages: string;
    nb_empl_ext: string;
    nb_empl_int: string;
    parking_collectif: boolean;
    nb_grenier: string;
    buanderie: boolean;
    renove: boolean;
    animaux_acceptes: boolean;
    cave_vin: boolean;
    antenne_satellite: boolean;
    volets_roulants: boolean;
    volets_electriques: boolean;
    porte_blindee: boolean;
    alarme: boolean;

    chauffage_gaz: boolean;
    chauffage_elec: boolean;
    chauffage_fuel: boolean;
    chauffage_collectif: boolean;
    chauffage_charbon: boolean;
    chauffage_granules: boolean;
    chauffage_clim: boolean;
    chauffage_cheminee: boolean;
    chauffage_insert: boolean;
    chauffage_central: boolean;
    chauffage_rad: boolean;

    chauffage_eau: string;
    double_vitrage: boolean;
    triple_vitrage: boolean;
    pompe_chaleur: boolean;
    chauffage_sol: boolean;
    ventillation_mecanique: boolean;
    geothermie: boolean;
    chaudiere_condensation: boolean;
    vmc_double_flux: boolean;
    solaire_thermique: boolean;
    solaire_photovoltaique: boolean;

    pieces: LotPiece[];
    descriptions: Description[];
    diagnostics: Diagnostic;
    photo: Photo;
    // proprietaire: Role;
    locataire: Role;
    proprietaires: LotProprietaire[];

    tct_id: string;
    type_transaction: TypeTransaction;
    tpt_id: string;
    type_passation: TypePassation;
    budget: number;
    commission: string;
    archive: string;
    roles_id_commercial: string;
    roles_id_commercial_secondaire: string;

    titre: string;
    date_entree: string;
    coup_coeur: string;
    prix_m2: string;
    prix_estime: string;
    prix_net: string;
    garantie_bancaire: string;
    caution: string;
    cacher_prix: boolean;
    charges_mensuelles: string;
    copropriete: boolean;
    nb_lots_copropriete: string;
    servitude: string;
    orientation: string;
    vue: string;
    exclusivite: string;
    disponible_le: string;
    disponibilite: string;
    honoraires_charge_de: string;

    autre_libelle: string;
    autre_description: string;

    honoraires_visite: string;
    honoraires_etat_des_lieux: string;
    taxe_habitation: string;
    taxe_fonciere: string;
    mitoyennete: boolean;
    etat_immeuble: string;
    assainissement: string;
    surface_plancher: string;
    surface_sol: string;
    surface_jardin:string;
    loi_carrez: boolean;
    numero_cadastral: string;
    viager: boolean;
    coup_modere: boolean;
    budget_annuel_charges: string;
    procedure_en_cours: boolean;
    nombre_appartements_copropriete: string;
    tfa_id: string;
    tto_id: string;
    mdt_id: string;
    date_livraison_initiale: string;
    date_livraison_revisee: string;

    date_signature_notaire: string;
    numero_acte: string;

    annonce: Annonce;
    passerelle_passation: string;
    proprietaire_computed_name: string;

    budget_lot: BudgetLot;

    surface_habitable: number;
    surface_terrasses_balcon: number;
    coeff_division_terrasses: number;
    agrements: AgrementsClient[];
    max_agrement: number;
    z16ProChamps: Array<any> = [];
    pal_id: String;

    tranchesLot: TranchesLot;

    prospect: Identite = null
    taxe_communale: number;

    z16pro: any;

    indice_type: string;

    validation: number;
    non_soumis_indexation: number;

    constructor(data?: any) {
        if (!data) {
            data = [];
        }

        this.id                              = data['id'] ? data['id'] : null;
        this.ref                             = data['ref'] ? data['ref'] : null;
        this.ref_metier                      = data['ref_metier'] ? data['ref_metier'] : null;
        this.statut                          = data['statut'] ? data['statut'] : 'open';
        this.draft                           = '0';
        this.agence_bureaux_id               = data['agence_bureaux_id'] ? data['agence_bureaux_id'] : null;
        this.batiments_id                    = data['batiments_id'] ? data['batiments_id'] : null;

        this.roles_id_proprietaire           = data['roles_id_proprietaire'] ? data['roles_id_proprietaire'] : null;
        this.roles_id_locataire              = data['roles_id_locataire'] ? data['roles_id_locataire'] : null;
        this.tpb_id                          = data['tpb_id'] ? data['tpb_id'] : null;
        this.tpd_id                          = data['tpd_id'] ? data['tpd_id'] : null;
        this.description                     = data['description'] ? data['description'] : null;
        this.date_achat                      = data['date_achat'] ? data['date_achat'] : null;
        this.date_vente                      = data['date_vente'] ? data['date_vente'] : null;
        this.achat_type                      = data['achat_type'] ? data['achat_type'] : 'ancien';
        this.surface                         = data['surface'] ? data['surface'] : null;
        this.surface_terrain_ares            = data['surface_terrain_ares'] ? data['surface_terrain_ares'] : null;
        this.surface_terrain                 = data['surface_terrain'] ? data['surface_terrain'] : null;
        this.surface_totale                  = data['surface_totale'] ? data['surface_totale'] : null;
        this.surface_utile                   = data['surface_utile'] ? data['surface_utile'] : null;
        this.surface_annexe_m2               = data['surface_annexe_m2'] ? data['surface_annexe_m2'] : null;
        this.surface_balcon                  = data['surface_balcon'] ? data['surface_balcon'] : null;
        this.surface_terrasse                = data['surface_terrasse'] ? data['surface_terrasse'] : null;
        this.surface_jardin                  = data['surface_jardin'] ? data['surface_jardin'] : null;
        this.etage                           = data['etage'] ? data['etage'] : 0;
        this.numero                          = data['numero'] ? data['numero'] : null;
        this.adresses_id                     = data['adresses_id'] ? data['adresses_id'] : null;
        this.nb_etages                       = data['nb_etages'] ? data['nb_etages'] : null;
        this.annee_construction              = data['annee_construction'] ? data['annee_construction'] : null;
        this.nb_chambres                     = data['nb_chambres'] ? data['nb_chambres'] : null;
        this.nb_pieces                       = data['nb_pieces'] ? data['nb_pieces'] : null;
        this.nb_parkings                     = data['nb_parkings'] ? data['nb_parkings'] : null;
        this.nb_sdb                          = data['nb_sdb'] ? data['nb_sdb'] : null;

        this.nb_garages                      = data['nb_garages'] ? data['nb_garages'] : null;
        this.nb_empl_ext                     = data['nb_empl_ext'] ? data['nb_empl_ext'] : null;
        this.nb_empl_int                     = data['nb_empl_int'] ? data['nb_empl_int'] : null;
        this.parking_collectif               = data['parking_collectif'] ? (data['parking_collectif'] === '1' ? true : false) : false;
        this.nb_grenier                      = data['nb_grenier'] ? data['nb_grenier'] : null;
        this.buanderie                       = data['buanderie'] ? (data['buanderie'] === '1' ? true : false) : false;
        this.renove                          = data['renove'] ? (data['renove'] === '1' ? true : false) : false;
        this.animaux_acceptes                = data['animaux_acceptes'] ? (data['animaux_acceptes'] === '1' ? true : false) : false;
        this.cave_vin                        = data['cave_vin'] ? (data['cave_vin'] === '1' ? true : false) : false;
        this.antenne_satellite               = data['antenne_satellite'] ? (data['antenne_satellite'] === '1' ? true : false) : false;
        this.volets_roulants                 = data['volets_roulants'] ? (data['volets_roulants'] === '1' ? true : false) : false;
        this.volets_electriques              = data['volets_electriques'] ? (data['volets_electriques'] === '1' ? true : false) : false;
        this.porte_blindee                   = data['porte_blindee'] ? (data['porte_blindee'] === '1' ? true : false) : false;
        this.alarme                          = data['alarme'] ? (data['alarme'] === '1' ? true : false) : false;

        this.piscine                         = data['piscine'] ? (data['piscine'] === '1' ? true : false) : false;
        this.jardin                          = data['jardin'] ? (data['jardin'] === '1' ? true : false) : false;
        this.terrasse                        = data['terrasse'] ? (data['terrasse'] === '1' ? true : false) : false;
        this.balcon                          = data['balcon'] ? (data['balcon'] === '1' ? true : false) : false;
        this.meuble                          = data['meuble'] ? (data['meuble'] === '1' ? true : false) : false;
        this.ascenseur                       = data['ascenseur'] ? (data['ascenseur'] === '1' ? true : false) : false;
        this.digicode                        = data['digicode'] ? (data['digicode'] === '1' ? true : false) : false;
        this.interphone                      = data['interphone'] ? (data['interphone'] === '1' ? true : false) : false;
        this.visiophone                      = data['visiophone'] ? (data['visiophone'] === '1' ? true : false) : false;
        this.acces_handicape                 = data['acces_handicape'] ? (data['acces_handicape'] === '1' ? true : false) : false;
        this.wellness                        = data['wellness'] ? (data['wellness'] === '1' ? true : false) : false;
        this.loggia                          = data['loggia'] ? (data['loggia'] === '1' ? true : false) : false;
        this.surface_loggia                  = data['surface_loggia'] ? data['surface_loggia'] : null;
        this.computed_name                   = data['computed_name'] ? data['computed_name'] : null;
        this.url                             = data['url'] ? data['url'] : null;
        this.visite_virtuelle                = data['visite_virtuelle'] ? data['visite_virtuelle'] : null;
        this.ref_auto                        = !!data['ref_auto'];

        this.chauffage_gaz                   = data['chauffage_gaz'] ? (data['chauffage_gaz'] === '1' ? true : false) : false;
        this.chauffage_elec                  = data['chauffage_elec'] ? (data['chauffage_elec'] === '1' ? true : false) : false;
        this.chauffage_fuel                  = data['chauffage_fuel'] ? (data['chauffage_fuel'] === '1' ? true : false) : false;
        this.chauffage_collectif             = data['chauffage_collectif'] ? (data['chauffage_collectif'] === '1' ? true : false) : false;
        this.chauffage_charbon               = data['chauffage_charbon'] ? (data['chauffage_charbon'] === '1' ? true : false) : false;
        this.chauffage_granules              = data['chauffage_granules'] ? (data['chauffage_granules'] === '1' ? true : false) : false;
        this.chauffage_clim                  = data['chauffage_clim'] ? (data['chauffage_clim'] === '1' ? true : false) : false;
        this.chauffage_cheminee              = data['chauffage_cheminee'] ? (data['chauffage_cheminee'] === '1' ? true : false) : false;
        this.chauffage_insert                = data['chauffage_insert'] ? (data['chauffage_insert'] === '1' ? true : false) : false;
        this.chauffage_central               = data['chauffage_central'] ? (data['chauffage_central'] === '1' ? true : false) : false;
        this.chauffage_rad                   = data['chauffage_rad'] ? (data['chauffage_rad'] === '1' ? true : false) : false;

        this.chauffage_eau                   = data['chauffage_eau'] ? data['chauffage_eau'] : null;
        this.double_vitrage                  = data['double_vitrage'] ? (data['double_vitrage'] === '1' ? true : false) : false;
        this.triple_vitrage                  = data['triple_vitrage'] ? (data['triple_vitrage'] === '1' ? true : false) : false;
        this.pompe_chaleur                   = data['pompe_chaleur'] ? (data['pompe_chaleur'] === '1' ? true : false) : false;
        this.chauffage_sol                   = data['chauffage_sol'] ? (data['chauffage_sol'] === '1' ? true : false) : false;
        this.ventillation_mecanique          = data['ventillation_mecanique'] ? (data['ventillation_mecanique'] === '1' ? true : false) : false;
        this.geothermie                      = data['geothermie'] ? (data['geothermie'] === '1' ? true : false) : false;
        this.chaudiere_condensation          = data['chaudiere_condensation'] ? (data['chaudiere_condensation'] === '1' ? true : false) : false;
        this.vmc_double_flux                 = data['vmc_double_flux'] ? (data['vmc_double_flux'] === '1' ? true : false) : false;
        this.solaire_thermique               = data['solaire_thermique'] ? (data['solaire_thermique'] === '1' ? true : false) : false;
        this.solaire_photovoltaique          = data['solaire_photovoltaique'] ? (data['solaire_photovoltaique'] === '1' ? true : false) : false;

        this.tct_id                          = data['tct_id'] ? data['tct_id'] : null;
        this.type_transaction                = data['type_transaction'] ? new TypeTransaction(data['type_transaction']) : new TypeTransaction();
        this.tpt_id                          = data['tpt_id'] ? data['tpt_id'] : null;
        this.type_passation                  = data['type_passation'] ? new TypePassation(data['type_passation']) : new TypePassation();
        this.budget                          = data['budget'] ? data['budget'] : null;
        this.commission                      = data['commission'] ? data['commission'] : null;
        this.archive                         = data['archive'] ? data['archive'] : '0';
        this.roles_id_commercial             = data['roles_id_commercial'] ? data['roles_id_commercial'] : null;
        this.roles_id_commercial_secondaire  = data['roles_id_commercial_secondaire'] || null;

        this.titre                           = data['titre'] ? data['titre'] : null;
        this.date_entree                     = data['date_entree'] ? data['date_entree'] : formatDate(new Date(), 'yyyy-MM-dd', 'en-US');
        this.disponible_le                   = data['disponible_le'] ? data['disponible_le'] : null;
        this.disponibilite                   = data['disponibilite'] ? data['disponibilite'] : null;
        this.coup_coeur                      = data['coup_coeur'] ? data['coup_coeur'] : null;
        this.prix_m2                         = data['prix_m2'] ? data['prix_m2'] : null;
        this.prix_estime                     = data['prix_estime'] ? data['prix_estime'] : null;
        this.cacher_prix                     = data['cacher_prix'] ? (data['cacher_prix'] === '1' ? true : false) : false;
        this.prix_net                        = data['prix_net'] ? data['prix_net'] : null;
        this.charges_mensuelles              = data['charges_mensuelles'] ? data['charges_mensuelles'] : null;
        this.garantie_bancaire               = data['garantie_bancaire'] ? data['garantie_bancaire'] : null;
        this.caution                         = data['caution'] ? data['caution'] : null;
        this.copropriete                     = data['copropriete'] ? (data['copropriete'] === '1' ? true : false) : false;
        this.nb_lots_copropriete             = data['nb_lots_copropriete'] ? data['nb_lots_copropriete'] : null;
        this.servitude                       = data['servitude'] ? data['servitude'] : null;
        this.orientation                     = data['orientation'] ? data['orientation'] : null;
        this.vue                             = data['vue'] ? data['vue'] : null;
        this.exclusivite                     = data['exclusivite'] ? data['exclusivite'] : null;
        this.autre_libelle                   = data['autre_libelle'] ? data['autre_libelle'] : null;
        this.autre_description               = data['autre_description'] ? data['autre_description'] : null;
        this.honoraires_charge_de            = data['honoraires_charge_de'] ? data['honoraires_charge_de'] : 'vendeur';

        this.honoraires_visite               = data['honoraires_visite'] ? data['honoraires_visite'] : null;
        this.honoraires_etat_des_lieux       = data['honoraires_etat_des_lieux'] ? data['honoraires_etat_des_lieux'] : null;
        this.taxe_habitation                 = data['taxe_habitation'] ? data['taxe_habitation'] : null;
        this.taxe_fonciere                   = data['taxe_fonciere'] ? data['taxe_fonciere'] : null;
        this.mitoyennete                     = data['mitoyennete'] ? (data['mitoyennete'] === '1' ? true : false) : false;
        this.etat_immeuble                   = data['etat_immeuble'] ? data['etat_immeuble'] : null;
        this.assainissement                  = data['assainissement'] ? data['assainissement'] : null;
        this.surface_plancher                = data['surface_plancher'] ? data['surface_plancher'] : null;
        this.surface_sol                     = data['surface_sol'] ? data['surface_sol'] : null;
        this.loi_carrez                      = data['loi_carrez'] ? (data['loi_carrez'] === '1' ? true : false) : false;
        this.numero_cadastral                = data['numero_cadastral'] ? data['numero_cadastral'] : null;
        this.viager                          = data['viager'] ? (data['viager'] === '1' ? true : false) : false;
        this.coup_modere                     = data['coup_modere'] ? (data['coup_modere'] === '1' ? true : false) : false;
        this.budget_annuel_charges           = data['budget_annuel_charges'] ? data['budget_annuel_charges'] : null;
        this.procedure_en_cours              = data['procedure_en_cours'] ? (data['procedure_en_cours'] === '1' ? true : false) : false;
        this.nombre_appartements_copropriete = data['nombre_appartements_copropriete'] ? data['nombre_appartements_copropriete'] : null;
        this.tfa_id                          = data['tfa_id'] ? data['tfa_id'] : null;
        this.tto_id                          = data['tto_id'] ? data['tto_id'] : null;
        this.mdt_id                          = data['mdt_id'] ? data['mdt_id'] : null;
        this.date_livraison_initiale         = data['date_livraison_initiale'] ? data['date_livraison_initiale'] : null;
        this.date_livraison_revisee          = data['date_livraison_revisee'] ? data['date_livraison_revisee'] : null;
        
        // this.proprietaire           = data['proprietaire'] ? new Role(data['proprietaire']) : new Role();
        this.locataire                       = data['locataire'] ? new Role(data['locataire']) : new Role();
        this.batiment                        = data['batiment'] ? new Batiment(data['batiment']) : new Batiment();
        this.adresse                         = data['adresse'] ? new Adresse(data['adresse']) : new Adresse();
        this.type_bien                       = data['type_bien'] ? new TypeBien(data['type_bien']) : new TypeBien();
        this.type_dalle                      = data['type_dalle'] ? new TypeDalle(data['type_dalle']) : new TypeDalle();
        this.type_toiture                    = data['type_toiture'] ? new TypeToiture(data['type_toiture']) : new TypeToiture();
        this.type_facade                     = data['type_facade'] ? new TypeFacade(data['type_facade']) : new TypeFacade();
        this.mandat                          = data['mandat'] ? new Mandat(data['mandat']) : new Mandat();
        this.pieces                          = data['pieces'] ? data['pieces'] : [];
        this.descriptions                    = data['descriptions'] ? data['descriptions'] : [];
        this.diagnostics                     = data['diagnostics'] ? new Diagnostic(data['diagnostics']) : new Diagnostic();
        this.photo                           = data['photo'] ? new Photo(data['photo']) : new Photo();
        this.annonce                         = data['annonce'] ? new Annonce(data['annonce']) : new Annonce();
        this.proprietaire_computed_name      = data['proprietaire_computed_name'] ? data['proprietaire_computed_name'] : null;
        this.agrements                       = data['agrements'] ? data['agrements'] : [];
        this.max_agrement                    = data['max_agrement'] ? data['max_agrement'] : 0;

        this.convention                      = this.initConvention(data);

        this.budget_lot                     = data['budget_lot'] ?  new BudgetLot(data['budget_lot']) : new BudgetLot();
        this.proprietaires                  = data['proprietaires'] ?  data['proprietaires'] : [];

        this.surface_terrasses_balcon       = data['surface_terrasses_balcon'] ?  data['surface_terrasses_balcon'] : null;
        this.coeff_division_terrasses       = data['coeff_division_terrasses'] ?  data['coeff_division_terrasses'] : null;
        this.surface_habitable              = data['surface_habitable'] ?  data['surface_habitable'] : null;
        this.date_signature_notaire         = data['date_signature_notaire'] ? data['date_signature_notaire'] : null;
        this.numero_acte                    = data['numero_acte'] ? data['numero_acte'] : null;
        this.pal_id                         = data['pal_id'] ? data['pal_id'] : null;

        this.tranchesLot                    = data['tranchesLot'] ? new TranchesLot(data['tranchesLot']) : new TranchesLot();
        this.taxe_communale                 = data['taxe_communale'] ? data['taxe_communale'] : 0.00;
        this.z16pro                         = data['z16pro'] ? data['z16pro'] : null;
        this.validation                     = data['validation'] ? data['validation'] : 2;
        this.non_soumis_indexation          = data['non_soumis_indexation'] ? data['non_soumis_indexation'] : null;
        this.initProprietaires(data['proprietaires']);
        this.initProspect(data['passation_role']);
    }


    static copy(lot: Lot, venteType: TypeTransaction, batiment: Batiment): Lot {
        const newLot = new Lot();
        
        for (let [key, value] of Object.entries(lot)) {
            if (typeof lot[key] !== 'object') {
                newLot[key] = value;
            }
        }

        newLot.id = '-1';
        newLot.numero += " (copie)";
        newLot.agence_bureaux_id = lot.agence_bureaux_id;
        newLot.batiments_id = lot.batiments_id;
        newLot.type_transaction = venteType;
        newLot.tct_id = lot.tct_id;
        newLot.ref = null;
        newLot.ref_auto = true;
        newLot.tranchesLot = lot.tranchesLot;
        newLot.tranchesLot.trl_lot_id = "-1";
        newLot.prix_m2 = lot.prix_m2;
        newLot.batiment = lot.batiment;

        newLot.nb_chambres = lot.nb_chambres;
        newLot.etage = lot.etage;
        newLot.tpb_id = lot.tpb_id;
        newLot.surface = lot.surface;
        newLot.surface_terrasses_balcon = lot.surface_terrasses_balcon;
        newLot.surface_terrasse = lot.surface_terrasse;
        newLot.surface_jardin = lot.surface_jardin;

        newLot.nb_etages = lot.nb_etages;
        newLot.achat_type = lot.achat_type;

        newLot.surface = lot.surface;
        newLot.surface_annexe_m2 = lot.surface_annexe_m2;
        newLot.surface_habitable = lot.surface_habitable;
        newLot.surface_balcon = lot.surface_balcon;
        newLot.surface_jardin = lot.surface_jardin;
        newLot.surface_loggia = lot.surface_loggia;
        newLot.surface_plancher = lot.surface_plancher;
        newLot.surface_sol = lot.surface_sol;
        newLot.surface_terrain = lot.surface_terrain;
        newLot.surface_terrain_ares = lot.surface_terrain_ares;
        newLot.surface_terrasse = lot.surface_terrasse;
        newLot.surface_terrasses_balcon = lot.surface_terrasses_balcon;
        newLot.surface_totale = lot.surface_totale;
        newLot.surface_utile = lot.surface_utile;

        newLot.type_passation = new TypePassation();
        newLot.tpt_id = null;
        newLot.proprietaires = null;

        newLot.budget_lot = new BudgetLot(lot.budget_lot);

        newLot.budget_lot.bgl_taxe_paye = null;
        newLot.budget_lot.bgl_taxe_paye_ttc = null;
        newLot.budget_lot.bgl_construction_realisee = 0;
        newLot.budget_lot.bgl_construction_a_realiser = newLot.budget_lot.bgl_quote_part_construction_ttc_2;
        newLot.budget_lot.bgl_qpt_facture = null;
        newLot.budget_lot.bgl_quote_part_architecte_payee = 0;
        newLot.budget_lot.bgl_quote_part_architecte_a_payer = newLot.budget_lot.bgl_quote_part_architecte_ttc_2;
        newLot.budget_lot.bgl_realise_a = 0;
        newLot.budget_lot.bgl_ind_id = batiment.ind_id;
        newLot.budget_lot.bgl_ind_indice = batiment.ind_indice;
        newLot.budget_lot.bgl_nombre_indice = 0;
        newLot.budget_lot.bgl_pourcentage_max_indice = 0;

        return newLot;
    }
    
    private initProprietaires(proprietaires): void {
        if (!proprietaires || !proprietaires.length) {
            this.proprietaires = [];
            return;
        }
        const tmp = [];
        this.proprietaires.forEach(item => {
            tmp.push(new LotProprietaire(item));
        });
        this.proprietaires = tmp;
    }

    private initConvention(data: any): Convention {
        const convention = new Convention(data['convention']);
        if (!convention.con_source) {
            convention.con_source = 'lots';
        }

        if (!convention.con_source_id) {
            convention.con_source_id = data['id'];
        }

        return convention;
    }

    private initProspect(data): void {
        if (this.type_passation && (this.type_passation.tpt_ref === 'reserve' || this.type_passation.tpt_ref === 'compromis')&& data && data['id']) {
            this.prospect = new Identite(data['identite']);
        }
    }
}
